<!-- Desktop Version -->
<div class="d-none d-lg-block" style="width:100vw"  >

    <div class="row">
      <div class="col-6 text-left align-middle">
        <a href="/admin/dashboard"> <img src="assets/logos/idraw-logo.svg" width="120vw"   alt="IDraw" class="img-responsive"></a>
      </div>
      <div class="col-3 text-right"></div>
      <div class="col-3 text-right align-middle">

        <nb-action class="user-action">
        <nb-user [nbContextMenu]="userMenu"
                 [name]="user?.email"
        >
        </nb-user>
      </nb-action>
      </div>

    </div>

</div>
<!-- Mobile Version -->
<div class="row d-lg-none">
  <div class="navbar-brand minimum">
    <a href="https://irvingfund.com"><img src="assets/logos/idraw-logo.svg" width="100vw" height="100vh" class="img-responsive"  alt="IDraw"></a>
  </div>
</div>



